import { NgModule, } from '@angular/core';

import { FilterPipe} from '../pipe/filter.pipe';
import { AuthPipe } from '../pipe/auth-pipe.pipe';
import { SortPipe } from '../pipe/sort.pipe';

@NgModule({
  imports: [
  ],
  declarations: [
    AuthPipe,
    FilterPipe,
    SortPipe
  ],
  exports: [
    AuthPipe,
    FilterPipe,
    SortPipe
  ]
})

export class SharedModule { }